import { Box, Paper, Stack, Tab, Tabs } from "@mui/material";
import { Localized } from "@fluent/react"

import { SubscriptionCard } from "./cards/SubscriptionCard";
import { useState } from "react";
import { CompanySetting } from "./companySettingsAPI";
import { CompanyUrsRequestMatchingSettingCard } from "./cards/CompanyUrsRequestMatchingSettingCard";
import { CompanyFilenameTemplateSettingCard } from "./cards/CompanyFilenameTemplateSettingCard";
import { CompanySettingsCard } from "./cards/CompanySettingsCard";
import { CompanyDocumentsSettingCard } from "./cards/CompanyDocumentsSettingCard";
import { CompanyRiskAnalysisSettingCard } from "./cards/CompanyRiskAnalysisSettingCard";
import { CompanyTaskReportSettingCard } from "./cards/CompanyTaskReportSettingCard";
import { CompanyPrintSettingsCard } from "./cards/CompanyPrintSettingsCard";
import { CompanyDevicesSettingCard } from "./cards/CompanyDevicesSettingCard";
import { CompanyComputerizedSystemsSettingCard } from "./cards/CompanyComputerizedSystemsSettingCard";
import { CompanyDocumentNumberRulesCard } from "../companyDocumentNumberRules/CompanyDocumentNumberRulesCard";


interface GeneralSettingsProps {
    companySettings: CompanySetting[];
    onUpdate: (updatedSettings: CompanySetting[]) => void;
}

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({ companySettings, onUpdate }) => {
    const [selectedTab, setSelectedTab] = useState(0);


    return (
        <Paper elevation={3} sx={{ width: "100%", height: "100%", display: "flex", flexGrow: 1 }}>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
                sx={{ borderRight: 1, borderColor: "divider", minWidth: 200, height: "100%" }}
            >
                <Tab
                    key={0}
                    label={<Localized id="company-settings-general">
                        <span>_general</span>
                    </Localized>}
                />
                <Tab
                    key={1}
                    label={<Localized id="company-settings-urs-request">
                        <span>_urs</span>
                    </Localized>} />
                <Tab
                    key={2}
                    label={<Localized id="company-settings-documents">
                        <span>_Dokumenty</span>
                    </Localized>} />
                <Tab
                    key={3}
                    label={<Localized id="company-settings-devices">
                        <span>_Urządzenia</span>
                    </Localized>} />
                <Tab
                    key={4}
                    label={<Localized id="company-settings-computerized-systems">
                        <span>_Systemy skomputeryzowane</span>
                    </Localized>} />
                <Tab
                    key={5}
                    label={<Localized id="company-settings-notifications">
                        <span>_Notifications</span>
                    </Localized>} />
                <Tab
                    key={6}
                    label={<Localized id="company-settings-print">
                        <span>_Print</span>
                    </Localized>} />
            </Tabs>
            <Box sx={{ flexGrow: 1, p: 2, display: "flex", flexDirection: "column" }}>
                {selectedTab === 0 && (
                    <Box display="flex" gap={2}>
                        <CompanySettingsCard companySettings={companySettings} onUpdate={onUpdate} />
                        <SubscriptionCard />
                    </Box>
                )}

                {selectedTab === 1 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyUrsRequestMatchingSettingCard companySettings={companySettings} onUpdate={onUpdate} />
                        <CompanyFilenameTemplateSettingCard
                            code="SUPPLIER_COMMENTED_PRINT_FILENAME_TEMPLATE"
                            secondaryCode="SUPPLIER_COMMENTED_EXCEL_FILENAME_TEMPLATE"
                            groupTitle={{ id: "company-settings-urs-filenames-title", fallback: "_Ustawienia nazw wydruków" }}
                            companySettings={companySettings}
                            onUpdate={onUpdate}
                        />
                    </Stack>
                )}

                {selectedTab === 2 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyDocumentsSettingCard companySettings={companySettings} onUpdate={onUpdate} />
                        <CompanyDocumentNumberRulesCard />

                        <CompanyRiskAnalysisSettingCard
                            companySettings={companySettings}
                            onUpdate={onUpdate}
                        />
                    </Stack>
                )}

                {selectedTab === 3 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyDevicesSettingCard companySettings={companySettings} onUpdate={onUpdate} />
                    </Stack>
                )}

                {selectedTab === 4 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyComputerizedSystemsSettingCard companySettings={companySettings} onUpdate={onUpdate} />
                    </Stack>
                )}

                {selectedTab === 5 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyTaskReportSettingCard companySettings={companySettings} onUpdate={onUpdate} />
                    </Stack>
                )}
                {selectedTab === 6 && (
                    <Stack direction="column" spacing={2}>
                        <CompanyPrintSettingsCard companySettings={companySettings} onUpdate={onUpdate} />
                        <CompanyFilenameTemplateSettingCard
                            code="DOCUMENT_PRINT_FILENAME_TEMPLATE"
                            secondaryCode="DOCUMENT_EXCEL_FILENAME_TEMPLATE"
                            groupTitle={{ id: "company-settings-document-filenames-title", fallback: "_Ustawienia nazw plików dokumentów" }}
                            companySettings={companySettings}
                            onUpdate={onUpdate}
                        />
                    </Stack>
                )}
            </Box>

        </Paper>

    )
}